import { TOGGLE_TIME_TO_PARK_CONTAINER } from "./displayTimeToParkContainerReducer"

export const toggleTimeToParkContainer = (value) => ({
    type: TOGGLE_TIME_TO_PARK_CONTAINER,
    payload: value
})